import React, { Component } from "react";
import { NavLink } from "react-router-dom";

function Header(props) {
  const { useState, useEffect } = React;
  const [click, setClick] = React.useState(false);
  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);
  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => setOpen(!isOpen);
  return (
    <div>
      <div className="main-header container">
        <div>
          <div className="mr-2 d-flex align-items-center"><i class="fas fa-map-marker" aria-hidden="true"></i> <p className="mb-0 ml-2">{props.address}</p></div>
        </div>
        <div className="d-flex">
          <select className="mr-2"><option selected>ENG</option><option>FR</option></select>
          <div className="mr-2 d-flex align-items-center"> <i class="fas fa-user"></i> <p className="mb-0 ml-2 cursor-pointer" onClick={toggleDropdown}>SIGN IN</p></div>
        </div>
      </div>
      <div className={click ? "main-container " : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container container p-0">
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <div className="d-flex justify-content-between menu-items">
              <li className="nav-item">

              </li>
              <li className="nav-item">

              </li>
            </div>
            <NavLink exact to={`/?hotelid=${props.code}`} className="nav-logo">
              <div>
                <img
                  className="logo"
                  src={process.env.REACT_APP_API_KEY_PROD + props.logo}
                ></img>
              </div>
            </NavLink>
            <div className="d-flex justify-content-between menu-items">
              <li className="nav-item ">

              </li>
              <li className="nav-item">

              </li>
            </div>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Header;
